/**
 * Security Summary — #1074 E2 placeholder (v1.0).
 *
 * The full security dashboard (attack-surface table, CVE counts, posture
 * tiles) was synthesised from code structure and a thin Snyk-style mock
 * when no real CVE feed was connected. For v1.0 we don't ship the CVE
 * adapters AND we want to be deliberate about RBAC before exposing per-user
 * security data, so the entire panel renders a "Coming in the next release"
 * placeholder with a "Suggest what this should show" link.
 *
 * The 700+ LOC of the attack-surface table and posture tiles are removed
 * in this commit; restore from git history when v1.1 wires up real CVE
 * scanning + RBAC.
 */

import { getBugReportConfig } from '../../utils/bugReportLink';

export function SecuritySummary(_props: { projectId?: string }) {
  const { enabled, href } = getBugReportConfig();
  return (
    <section
      id="security-summary"
      data-testid="security-summary"
      data-placeholder="true"
      tabIndex={-1}
      className="mb-8 border border-border rounded-lg p-6 bg-muted/20 scroll-mt-20"
    >
      <div className="flex items-start justify-between gap-4 flex-wrap">
        <div>
          <h2 className="text-xl font-semibold flex items-center gap-2">
            Security summary
            <span className="text-[10px] px-1.5 py-0.5 rounded uppercase tracking-wide bg-amber-100 dark:bg-amber-900/30 text-amber-700 dark:text-amber-300">
              Coming next release
            </span>
          </h2>
          <p className="text-sm text-muted-foreground mt-2 max-w-xl">
            We&apos;re building CVE-feed integrations and a per-project access
            model so this panel can surface attack-surface, dependency
            vulnerabilities, and remediation priorities. We&apos;d love to
            hear what you&apos;d find most useful — the issue tracker is the
            right place to weigh in.
          </p>
        </div>
        {enabled && (
          <a
            href={href}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-1 text-sm font-medium text-primary hover:underline whitespace-nowrap"
          >
            Suggest what this should show
            <svg className="w-3 h-3" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" />
            </svg>
          </a>
        )}
      </div>
    </section>
  );
}
